import { useState } from "react"
import MainPage from "./MainPage/MainPage"

const DailySales = () => {
  const tabs = ["Main Page"]
  const [activeTab, setActiveTab] = useState(tabs[0])

  return (
    <>
      <div className="d-flex" style={{ backgroundColor: "#FBBD34" }}>
        {tabs.map((tab) => (
          <div
            className="fw-semibold"
            style={{
              color: "white",
              cursor: "pointer",
              transition: "color 1s ease",
              fontSize: "1.25rem",
              padding: ".5rem 1rem",
              borderBottom: activeTab === tab ? "4px solid black" : "none",
            }}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </div>
        ))}
      </div>

      {activeTab === "Main Page" && <MainPage />}
    </>
  )
}

export default DailySales
